import React from "react";
import styled from "styled-components";
import { Button, MenuItem } from "@blueprintjs/core";
import { ItemRenderer, Select } from "@blueprintjs/select";

import {
  ALL_LANGUAGES,
  Language,
  LanguageDefinition,
  languageMaturityTag,
  VISIBLE_LANGUAGES,
} from "@utils";

import "./LanguageSelect.scss";

const MaturityTag = styled.span`
  font-size: small;
  color: var(--global-mid-gray);
`;

const LanguageItem = styled(MenuItem)`
  &.bp3-active [data-element="MaturityTag"] {
    color: var(--global-light-gray);
  }
`;

const LanguageSingleSelect = Select.ofType<LanguageDefinition>();

const renderExample: ItemRenderer<LanguageDefinition> = (
  example,
  { modifiers, handleClick }
) => {
  if (!modifiers.matchesPredicate) {
    return null;
  }
  return (
    <LanguageItem
      active={modifiers.active}
      key={example.id}
      onClick={handleClick}
      text={friendlySelectLanguage(example)}
      shouldDismissPopover={false}
    />
  );
};

interface Props {
  onChange: (language: Language) => void;
  value: Language;
}

const friendlySelectLanguage = (langDef: LanguageDefinition) => (
  <span>
    {langDef.name}
    <MaturityTag>{languageMaturityTag[langDef.maturity]}</MaturityTag>
  </span>
);

export const LanguageSelect: React.FC<Props> = ({ onChange, value }) => {
  const langDef = ALL_LANGUAGES[value] || { id: value, name: value };

  return (
    <LanguageSingleSelect
      items={Object.values(VISIBLE_LANGUAGES)}
      itemRenderer={renderExample}
      filterable={false}
      onItemSelect={(selected: LanguageDefinition) => onChange(selected.id)}
      popoverProps={{
        minimal: false,
        position: "bottom-right",
      }}
    >
      <Button className="languageselectbutton" rightIcon="caret-down">
        {friendlySelectLanguage(langDef)}
      </Button>
    </LanguageSingleSelect>
  );
};
